import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SearchIcon from '@material-ui/icons/Search';
import styles from './ParticipatingOrgList.module.scss';
import loadingIcon from '../../../assets/images/np_loading.png';
import _ from 'lodash';
import { sortOrganisationsByCategory } from '../../../utils/SortHelper';
import NominateOrganisation from '../nominateOrganisation/NominateOrganisation';
import ReactModal from 'react-modal';
import { isMobile } from 'react-device-detect';
import ParticipatingOrgItem from '../../common/participating-org-item/participatingOrgItem';

ReactModal.setAppElement('#root');

const ParticipatingOrgList = props => {
  const dispatch = useDispatch();
  const participatingOrganisationsData = useSelector(state => state.participatingOrganisations);
  const { searchingOrganisations, organisationNames, categories } = participatingOrganisationsData;

  const [seeAllFilters, setSeeAllFilter] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [searchByName, setSearchByName] = useState('');
  const [isFilterModalOpen, setFilterModalOpen] = useState(false);
  const [isStateInfoModalOpen, setStateInfoModalOpen] = useState(false);
  const [isOptionsOpen, setOpenOtions] = useState(false);
  const [isAllExpanded, setAllExpanded] = useState(props.expandAll && !isMobile);
  const [showAccordion, setShowAccordion] = useState(true);
  const [openIndex, setOpenIndex] = useState([]);

  const participatingOrganisationsByCategory =
    organisationNames && sortOrganisationsByCategory([...organisationNames]);

  const filteredCategories = participatingOrganisationsByCategory
    .filter(org => {
      if (!selectedCategories || !selectedCategories.length) {
        return true;
      } else {
        return !!selectedCategories.find(sc => sc.value === org.sector);
      }
    })
    .filter(org => {
      if (!searchByName) {
        return true;
      } else {
        return org.displayName.toLowerCase().includes(searchByName.toLowerCase());
      }
    });

  const showFilterOption = index => {
    if (seeAllFilters) {
      return true;
    } else if (index < 7) {
      return true;
    }
    return false;
  };

  const getSelectedCategoryCount = category => {
    return props.selectedNotifiableOrganisations.filter(v => v.category === category).length || 0;
  };

  window.addEventListener('click', function(e) {
    if (!document.getElementById('options')?.contains(e.target) && isOptionsOpen) {
      setOpenOtions(false);
      e.stopPropagation();
    }
  });

  useEffect(() => {
    if (isFilterModalOpen || isStateInfoModalOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.height = '100%';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = 'unset';
      document.body.style.height = 'initial';
      document.body.style.position = 'initial';
      document.body.style.width = 'initial';
    }
  }, [isFilterModalOpen, isStateInfoModalOpen]);

  const onOrgItemHeaderClick = ind => {
    const catArry = [...openIndex];
    catArry[ind] = !catArry[ind];
    setOpenIndex(catArry);
  };

  return (
    <div className={`${props.fullWidth ? null : `container`}`}>
      <div className={styles.siteContainer}>
        <div className={styles.siteSubCont}>
          <div className={`${styles.mainCont} ${styles.mainContFullWidth}`}>
            {searchingOrganisations ? (
              <div className={styles.loadingCont}>
                <img src={loadingIcon} alt={'loading'} className={styles.spinner} />
                <div>Loading...</div>
              </div>
            ) : (
              <>
                <div className={`row ${styles.organisationsFrame}`}>
                  <div
                    className={`${styles.noMobilePad} col-12 ${props.fullWidth ? '' : 'col-lg-8'}`}
                  >
                    <div className={`d-flex align-items-center ${styles.listOptions}`}>
                      <div className={styles.searchInput}>
                        <div className={styles.magnifierCont}>
                          <SearchIcon className={styles.magnifier} fontSize={'large'} />
                        </div>
                        <input
                          id={`searchByName`}
                          className={`${styles.inputBox} ${styles.searchInputBox}`}
                          value={searchByName}
                          onChange={event => setSearchByName(event?.target?.value.trimStart())}
                        />
                      </div>
                      <div className={`${styles.options} `}>
                        <a
                          onClick={e => {
                            setAllExpanded(true);
                            setOpenOtions(!isOptionsOpen);
                            setShowAccordion(false);
                            setTimeout(function() {
                              setShowAccordion(true);
                            }, 0);
                            e.stopPropagation();
                          }}
                        >
                          Expand all
                        </a>
                        <a
                          onClick={e => {
                            setShowAccordion(false);
                            setAllExpanded(false);
                            setOpenOtions(!isOptionsOpen);
                            setTimeout(function() {
                              setShowAccordion(true);
                            }, 0);
                            e.stopPropagation();
                          }}
                        >
                          Close all
                        </a>
                      </div>
                    </div>

                    {Object.values(_.groupBy(participatingOrganisationsByCategory, 'category')).map(
                      (categoryArray, ind) => {
                        const category = categoryArray[0].category;
                        if (filteredCategories.findIndex(i => i.category === category) > -1) {
                          return (
                            <div className={styles.participatingOrgItem}>
                              <ParticipatingOrgItem
                                category={category}
                                categoryArray={filteredCategories.filter(
                                  c => c.category === category
                                )}
                                showCheckbox={false}
                                clearError={props.clearError}
                                setSelectedOrganisations={props.setSelectedOrganisations}
                                filterIsAwareSuperSubsidiariesSelected={
                                  props.filterIsAwareSuperSubsidiariesSelected
                                }
                                setIsAwareSubsidiaryShown={props.setIsAwareSubsidiaryShown}
                                selectionEnabled={props.selectionEnabled}
                                selectedNotifiableOrganisations={
                                  props.selectedNotifiableOrganisations
                                }
                                index={ind}
                                openIndex={openIndex[ind]}
                                onHeaderClick={onOrgItemHeaderClick}
                              ></ParticipatingOrgItem>
                            </div>
                          );
                        }
                      }
                    )}

                    {props.showNominateOrg ? <NominateOrganisation /> : null}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParticipatingOrgList;
